'use client'

// THEME COMPLIANCE: All UI implementations must support both dark and light themes.

import * as React from 'react'
import { useRouter } from 'next/navigation'
import { cn } from '@/lib/utils'
import { NeumorphicCard } from '@/components/NeumorphicThemes/NeumorphicCard'

// Neumorphic shadow on the brand-gradient button (Figma Frame 427319239).
const BUTTON_SHADOW =
  '-10px -10px 30px var(--neu-shadow-light), 10px 10px 30px var(--neu-shadow-dark)'

export default function FinalCTASection() {
  const router = useRouter()

  return (
    <section className="relative py-12 md:py-24 text-white">
      <div className="px-4 sm:px-6 lg:px-8">
        {/* Partner CTA — Figma 4202:181430 (Frame 427319426): #303135 neumorphic
            surface, 16px radius, 588×349 @ desktop, 54×63 padding. NeumorphicCard
            supplies bg-neu-surface (#303135) + shadow-neumorphic + the radius. */}
        <NeumorphicCard
          className={cn(
            'mx-auto max-w-[588px]',
            'px-6 py-10 sm:px-10 sm:py-12 md:px-[54px] md:py-[63px]'
          )}
        >
          {/* Heading / subtitle / button stacked with 28px gaps (Frame 427319269). */}
          <div className="flex flex-col items-center text-center gap-6 md:gap-7">
            {/* PARTNER WITH NPFC — Impact 48px / line-height 59px. Text lives directly
                in <h2> so the global `* { font-family: Montserrat }` rule can't hijack it. */}
            <h2
              className={cn(
                'uppercase text-white',
                'text-3xl sm:text-4xl md:text-[44px] xl:text-[48px]'
              )}
              style={{
                fontFamily: '"Impact", var(--font-anton), "Arial Black", sans-serif',
                fontWeight: 400,
                lineHeight: 1.23,
                letterSpacing: '0.15px'
              }}
            >
              PARTNER WITH NPFC
            </h2>

            {/* Subtitle — Montserrat Medium 16px / 20px, uppercase. */}
            <p
              className={cn(
                'font-montserrat font-medium uppercase text-white',
                'text-xs sm:text-sm md:text-base max-w-[455px]'
              )}
              style={{ lineHeight: 1.25, letterSpacing: '0.15px' }}
            >
              PUT YOUR BRAND IN FRONT OF MILLIONS OF FOOTBALL FANS BUILT FOR CONSTANT ENGAGEMENTS.
            </p>

            {/* BECOME A PARTNER — brand gradient, neumorphic shadow, 48px tall, 16px radius. */}
            <button
              type="button"
              onClick={() => router.push('/contact')}
              className={cn(
                'w-full inline-flex h-12 items-center justify-center rounded-2xl px-[34px]',
                'bg-gradient-to-r from-neu-brand-from to-neu-brand-to',
                'font-montserrat font-bold text-white text-sm sm:text-base',
                'transition-transform duration-300 hover:-translate-y-0.5 active:scale-[0.99]',
                'focus:outline-none focus:ring-2 focus:ring-sky-300/60'
              )}
              style={{ boxShadow: BUTTON_SHADOW, letterSpacing: '0.15px' }}
            >
              BECOME A PARTNER
            </button>
          </div>
        </NeumorphicCard>
      </div>
    </section>
  )
}
